import React, { useState, useEffect } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useDispatch, useSelector } from 'react-redux';
import { getProfileReviewsAPI, UpdateProfileReviewStatusAPI } from '../../redux/slices/profileReviewSlice';
import { Link, useNavigate } from 'react-router-dom';
import { errorHandler } from '../../constants/base';
import { toast } from 'react-toastify';

const ProfileRewiew = () => {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.superAdminProfileReview.loading);
    const btnLoading = useSelector(state => state.superAdminProfileReview.btnLoading);
    const profileReview = useSelector((state) => state?.superAdminProfileReview?.profileReview);
    const pagination = useSelector((state) => state?.superAdminProfileReview?.pagination);
    const [currentPage, setCurrentPage] = useState(pagination.current_page);

    const [reasonForBlock, setReasonForBlock] = useState("");

    const navigate = useNavigate()

    // Fetch corporates based on the current page
    const fetchCorporates = async (page = currentPage) => {
        try {
            await dispatch(getProfileReviewsAPI(page));
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCorporates(currentPage);
    }, [currentPage]);

    // Handle page navigation
    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const [blockID, setBlockID] = useState("")

    const handleProfileReviewStatus = async (id, newStatus) => {
        const statusUpdate = {
            id: id || blockID,
            status: newStatus,
            reason: reasonForBlock
        }

        const res = await dispatch(UpdateProfileReviewStatusAPI(statusUpdate))

        if (res.type === 'UpdateProfileReviewStatusAPI/fulfilled') {
            if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                fetchCorporates(currentPage);
                toast.success("Status Update Successfully");
                navigate('/admin/profile/review')

                const closeButton = document.querySelector("#close-btn-update-model");
                if (closeButton) {
                    closeButton.click();
                }

            } else {
                errorHandler(res.payload.errors);
            }
        } else if (res.type === 'UpdateProfileReviewStatusAPI/rejected') {
            errorHandler(res.payload.errors);
            const closeButton = document.querySelector("#close-btn-update-model");
            if (closeButton) {
                closeButton.click();
            }
        } else {
            toast.error('Sorry, something went wrong!');
        }
    };


    return (
        <>
            <AdminDashboardLayout>
                {loading ? <div className="loading-center-on-page">
                    <i
                        style={{ fontSize: "52px" }}
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                </div> : <div>
                    <table className="table superadmin-table-box">
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col">Full Name</th>
                                <th scope="col">Email</th>
                                {/* <th scope="col" className="text-center">Phone</th>
                                <th scope="col">Role</th>
                                <th scope="col" className="text-center">Subscription</th> */}
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {profileReview?.map((item, index) => {
                                return <tr>
                                    <th scope="row" className="text-center">{index + 1}</th>
                                    <td>{item?.name}</td>
                                    <td>{item?.email}</td>
                                    <td>
                                        <div className="flex-btn-box">
                                            <button value="active" className='btn btn-primary me-2' onClick={(e) => handleProfileReviewStatus(item?.id, e.target.value)}>
                                                Active
                                            </button>

                                            <button className='btn btn-danger' onClick={() => setBlockID(item?.id)} data-bs-toggle="modal" href="#exampleModalToggle3" role="button">
                                                Block
                                            </button>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="actions-box text-center">
                                            <Link to={`/admin/profile/view/${item?.id}`}>
                                                <i className="fas fa-eye"></i>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div className="pagination">
                        {pagination.current_page > 1 && (
                            <button onClick={() => handlePageChange(pagination.current_page - 1)}>&laquo; Previous</button>
                        )}

                        {[...Array(pagination.total_pages)].map((_, i) => (
                            pagination.total_pages >= 2 ?
                                <button
                                    key={i + 1}
                                    className={i + 1 === pagination.current_page ? 'active' : ''}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </button> : ""
                        ))}

                        {pagination.current_page < pagination.total_pages && (
                            <button onClick={() => handlePageChange(pagination.current_page + 1)}>Next &raquo;</button>
                        )}
                    </div>
                </div>}
            </AdminDashboardLayout>

            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" id='close-btn-update-model' data-bs-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12 mt-4">
                                        <label for="reson-input" className="reason-for-block w-100">
                                            <h2 className='mb-2'>Please provide a valid reason for block.</h2>
                                            <textarea name="reason" value={reasonForBlock} onChange={(e) => setReasonForBlock(e.target.value)} id="reson-input"></textarea>
                                        </label>

                                        <div className="d-flex justify-content-end mt-3">
                                            <button type='submit' value="block" onClick={(e) => handleProfileReviewStatus("", e.target.value)} className='btn btn-danger'>

                                                {btnLoading ? <i
                                                    style={{ fontSize: "22px" }}
                                                    className="fa-solid fa-spinner fa-spin"
                                                ></i> : "Block"}

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileRewiew